module.exports = __webpack_public_path__ + "static/media/more-onogate.f09bf933.png";